
<section class="pickup-ad-container-wrapper">
  <h1>ピックアップ</h1>

  <SpiningDubblesLoading v-if="isLoading" class="loading" />
  <div v-else-if="pickupAds.length > 0">
    <PickupAdLinkItem
      v-for="(item, i) in pickupAds"
      v-bind="item"
      :key="`pickup_ad_${i}`"
      class="pickup-ad-article"
      @read="$emit('read', $event)"
    />
  </div>
  <p v-else class="non-registered">ピックアップが登録されていません</p>
</section>
